// extracted by mini-css-extract-plugin
export default {"sigCanvas":"ManualSignature_sigCanvas__TuqK-"};